module.exports = __webpack_public_path__ + "img/rona_5kl.e5638b92.jpg";